import { useContext } from 'react'

import { SurveysContext } from '@/contexts/indications'

interface UseExitLogicModalProps {
  showExitLogicModal: () => void
}

export const useExitLogicModal = (): UseExitLogicModalProps => {
  const { setShowExitLogicModal } = useContext(SurveysContext)

  const showExitLogicModal = () => {
    setShowExitLogicModal(true)
  }

  return {
    showExitLogicModal
  }
}
